<template>
    <!-- Authenticated Users for Quiz -->
    <quiz-app-authenticated-view v-model="data" v-if="data"></quiz-app-authenticated-view>

    <!-- Authentication Form-->
    <div v-else class="min-h-screen flex justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <quiz-app-authentication-form  @success="data = $event"></quiz-app-authentication-form>
    </div>
</template>
<script>
    export default {

        data() {
            return {
                data: null,
            }
        },
    }
</script>
